/**
 * This file contains prop => style functions related to a UI elements
 * dimensions.
 */
import {
  HeightProperty,
  MinHeightProperty,
  MinWidthProperty,
  WidthProperty,
  MaxHeightProperty,
  MaxWidthProperty
  // eslint-disable-next-line import/no-unresolved
} from "csstype"

type Size = string | number
export type Height = HeightProperty<Size>
export type HeightProp = {
  /**
   * The CSS height property. Numbers will automatically be converted to pixels.
   */
  height?: Height
}
export type MaxHeight = MaxHeightProperty<Size>
export type MaxHeightProp = {
  /**
   * The CSS max-height property. Numbers will automatically be converted to
   * pixels.
   */
  maxHeight?: MaxHeight
}
export type MinHeight = MinHeightProperty<Size>
export type MinHeightProp = {
  /**
   * The CSS min-height property. Numbers will automatically be converted to
   * pixels.
   */
  minHeight?: MinHeight
}
export type MaxWidth = MaxWidthProperty<Size>
export type MaxWidthProp = {
  /**
   * The CSS max-width property. Numbers will automatically be converted to
   * pixels.
   */
  maxWidth?: MaxWidth
}
export type MinWidth = MinWidthProperty<Size>
export type MinWidthProp = {
  /**
   * The CSS min-width property. Numbers will automatically be converted to
   * pixels.
   */
  minWidth?: MinWidth
}
export type Width = WidthProperty<Size>
export type WidthProp = {
  /**
   * The CSS width property. Numbers will automatically be converted to pixels.
   */
  width?: Width
}
export type Props = HeightProp &
  MaxHeightProp &
  MinHeightProp &
  WidthProp &
  MaxWidthProp &
  MinWidthProp

const prop = <T>(key: keyof Props) => (props: Record<string, any>): {} | T =>
  props[key] === undefined ? {} : { [key]: props[key] }

const height = prop<{ height: Height }>("height")
const width = prop<{ width: Width }>("width")
const maxHeight = prop<{ maxHeight: MaxHeight }>("maxHeight")
const minHeight = prop<{ minHeight: MinHeight }>("minHeight")
const maxWidth = prop<{ maxWidth: MaxWidth }>("maxWidth")
const minWidth = prop<{ minWidth: MinWidth }>("minWidth")

const interpolations = {
  height,
  width,
  maxHeight,
  maxWidth,
  minHeight,
  minWidth
}

export default interpolations
